export class ApplicationFamilySlug {
  static OLA_INSTRUMENT_UPLOADER_APP_FAMILY_SLUG = "illumina-inc.instrument-uploader";
}

